/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Events_TitleInputs */

const cs_portals_events_title = /** @type {(inputs: Portals_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historie publikace`)
};

const en_portals_events_title = /** @type {(inputs: Portals_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication history`)
};

/**
* | output |
* | --- |
* | "Publication history" |
*
* @param {Portals_Events_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_events_title = /** @type {((inputs?: Portals_Events_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Events_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_events_title(inputs)
	return cs_portals_events_title(inputs)
});